<template>
	<v-alert :value="documents.length" type="info" class="ml-4 mr-4 mb-3 alert">
		Dla następujących dokumentów wskazano więcej niż jedną datę zapłaty: {{payments.join(", ")}}
	</v-alert>
</template>

<script>
export default {
  name: "ProjectInvoicesMultipleDatesWarning",

  data() {
    return {
      showAlert: true,
      documents: []
    };
  },

  computed: {
    payments() {
      let payments = [];
      this.documents.forEach(document => {
        let number = document.documentNumber;
        let dates = document.paymentDates.join(", ");
        payments.push(number + " (" + dates + ")");
      });
      return payments;
    }
  },

  watch: {
    invoices: {
      handler (val) {
        this.documents = [];
        val.forEach(document => {
          if (document.paymentDates.length > 1) {
            this.documents.push(document);
          }
        });
      },
      immediate: true
    }
  },

  props: {
    invoices: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
@media print {
  .alert {
    background-color: lightgrey !important;
    color: black;
    border: none;
  }
  .alert >>> .v-icon {
    display: none;
  }
}
</style>
